'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../i-bem/i-bem.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'icon',
    tag: 'span',
    mods: function mods(_ref) {
        var type = _ref.type,
            action = _ref.action,
            direction = _ref.direction,
            glyph = _ref.glyph,
            size = _ref.size,
            disabled = _ref.disabled;

        return { type: type, action: action, direction: direction, glyph: glyph, size: size, disabled: disabled };
    },
    attrs: function attrs(_ref2) {
        var url = _ref2.url,
            id = _ref2.id,
            alt = _ref2.alt,
            _ref2$style = _ref2.style,
            style = _ref2$style === undefined ? {} : _ref2$style,
            _attrs = _ref2.attrs;

        if (url !== undefined) {
            style['backgroundImage'] = 'url(\'' + url + '\')';
        }

        return _extends({
            id: id,
            alt: alt,
            style: style
        }, _attrs);
    }
}, {
    propTypes: {
        id: _propTypes2.default.string,
        url: _propTypes2.default.string,
        style: _propTypes2.default.object,
        direction: _propTypes2.default.string,
        glyph: _propTypes2.default.string,
        size: _propTypes2.default.oneOf(['ns', 'xs', 's', 'm', 'n', 'l', 'head'])
    },
    isIcon: function isIcon(child) {
        return child && typeof child.type === 'function' && child.type.displayName === 'icon';
    }
});